import { useState } from 'react';
import { faClone } from '@fortawesome/pro-regular-svg-icons';
import { Button, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useNavigate } from 'react-router-dom';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { ManageRoomDetail } from '../../manage-room.types';
import { useCloneRoomMutation } from '../../manage-room.slice';
import { SettingCard } from '../setting-card';
import { WarningInfoBox } from '../warning-info-box';
import { ModalLayout } from '../modal';
import { StyledCloneContentContainer, StyledCloneIcon, StyledCloneText } from './clone.styles';
export const CloneTab = ({
  roomDetails
}: {
  roomDetails: ManageRoomDetail;
}) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [cloneRoom] = useCloneRoomMutation();
  const handleCloneRoom = async () => {
    try {
      await cloneRoom(roomDetails?._id).unwrap();
      NotificationDispatch('success', 'Room successfully cloned');
      navigate('/rooms?tab=manage-rooms');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error?.data?.message : 'Something went wrong.');
      setOpen(false);
    }
  };
  return <section aria-label="Clone Tab" data-sentry-component="CloneTab" data-sentry-source-file="clone-tab.tsx">
      <SettingCard title="Clone" icon={faClone} data-sentry-element="SettingCard" data-sentry-source-file="clone-tab.tsx">
        <StyledCloneContentContainer data-sentry-element="StyledCloneContentContainer" data-sentry-source-file="clone-tab.tsx">
          <StyledCloneText data-sentry-element="StyledCloneText" data-sentry-source-file="clone-tab.tsx">A new room will be created with all current tasks.</StyledCloneText>
          <WarningInfoBox warningText={<>
                This room currently has cloning enabled for all users. Please note that when a user clones a room, they
                get access to the clone’s manage page, including cloned content, questions, and answers. Leaving the
                cloning feature enabled can lead to unauthorized users cloning the room and getting unrestricted access
                to correct answers. You can disable cloning on the <strong>&quot;General settings&quot;</strong> tab.
              </>} data-sentry-element="WarningInfoBox" data-sentry-source-file="clone-tab.tsx" />
        </StyledCloneContentContainer>

        <Button color="add" onClick={() => setOpen(true)} data-sentry-element="Button" data-sentry-source-file="clone-tab.tsx">
          <StyledCloneIcon icon={faClone} data-sentry-element="StyledCloneIcon" data-sentry-source-file="clone-tab.tsx" />
          Clone
        </Button>
      </SettingCard>

      <ModalLayout showTriggerElement={false} open={open} openChange={setOpen} showWarnBox={false} actionButtonText="Clone room" modalTitleText="Clone room" closeButtonText="Close"
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    handleActionButton={handleCloneRoom} data-sentry-element="ModalLayout" data-sentry-source-file="clone-tab.tsx">
        <p>Are you sure you want to clone this room?</p>
      </ModalLayout>
    </section>;
};